import { render, staticRenderFns } from "./CollectionMailContacts.vue?vue&type=template&id=31da31ae&scoped=true&"
import script from "./CollectionMailContacts.vue?vue&type=script&lang=ts&"
export * from "./CollectionMailContacts.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionMailContacts.vue?vue&type=style&index=0&id=31da31ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31da31ae",
  null
  
)

export default component.exports